'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowDown = function TiArrowDown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.8 22.2c-0.6-0.7-1.7-0.7-2.3 0l-3.8 3.8v-12.7c0-0.9-0.8-1.6-1.7-1.6s-1.7 0.7-1.7 1.6v12.7l-3.8-3.8c-0.6-0.7-1.7-0.7-2.3 0s-0.7 1.7 0 2.3l7.8 7.9 7.8-7.9c0.7-0.6 0.7-1.7 0-2.3z' })
        )
    );
};

exports.default = TiArrowDown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-down.js
// module id = 1947
// module chunks = 0